import React, { useEffect, useState } from 'react';
import { showSuccessToast } from '../../PluginsMenu/Toastr/Toastr';
import { useGetPreferencesQuery, useUpdatePreferencesMutation } from '../../../../store/services/tutor/PreferenceService';


export const TutorNotificationPreferences = () => {
    const { data, isLoading, isSuccess, refetch } = useGetPreferencesQuery();
    const [updatePreferences] = useUpdatePreferencesMutation();
    const [preferences, setPreferences] = useState([]);

    // Initialize preferences when API call succeeds
    useEffect(() => {
        if (isSuccess && data?.data) {
            setPreferences(data.data);
        }
    }, [isSuccess, data]);

    const handleChange = (e, id) => {
        const { checked } = e.target;
        setPreferences((prev) =>
            prev.map((pref) =>
                pref.id === id ? { ...pref, isSelected: checked } : pref
            )
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const selectedIds = preferences
            .filter(pref => pref.isSelected)
            .map(pref => pref.id);
    
        const response = await updatePreferences({preferences: selectedIds});
        if(response.data.succeeded) {
            showSuccessToast("Notification Preferences Updated Successfully");
            await refetch();
        }
    };

    if (isLoading) return <p>Loading preferences...</p>;

    return (
        <div className="card profile-card card-bx ">
            <div className="card-header">
                <h6 className="title">Notification Preferences</h6>
            </div>
            <form onSubmit={handleSubmit}>
                <div className="card-body">
                    <p>Select how you would like to receive notifications:</p>
                    {preferences.map((pref) => (
                        console.log("pref = ", pref),
                        <div className="form-check" key={pref.id}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id={`pref-${pref.id}`}
                                checked={pref.isSelected}
                                onChange={(e) => handleChange(e, pref.id)}
                            />
                            <label className="form-check-label" htmlFor={`pref-${pref.id}`}>
                                {pref.name} Notifications
                            </label>
                        </div>
                    ))}
                </div>
                <div className="card-footer align-items-center d-flex">
                    <button className="btn btn-primary" type="submit">
                        SAVE PREFERENCES
                    </button>
                </div>
            </form>
        </div>
    );
};